import { UserModel } from './UserModel';

export enum UserTypes {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  NORMAL = 'NORMAL',
}

export const getTypeOfUser = (user: UserModel): UserTypes => {
  if (user.admin) {
    return UserTypes.ADMIN;
  } else if (user.owner) {
    return UserTypes.OWNER;
  } else {
    return UserTypes.NORMAL;
  }
};

export const initialLoginNavigation = (userType: string): string => {
  return {
    ADMIN: '/admin-profile',
    OWNER: '/partner-profile/my-properties',
    NORMAL: '/home',
  }[userType] as string;
};

export const getUserTypeProfileUrl = (userType: string): string => {
  return {
    ADMIN: '/admin-profile',
    OWNER: '/partner-profile/reservations',
    NORMAL: '/user-profile/reservations',
  }[userType] as string;
};
